import React from 'react';

import useGame from './useGame';

type Props = ReturnType<typeof useGame>;

const GameContext = React.createContext<Props>({} as Props);

export default GameContext;
